module.exports = __webpack_public_path__ + "static/media/Cabinet_After.00b311ca.jpg";